export default "__VITE_ASSET__D3Zc3xzi__"